import { commonUtils, REGION_OUTSIDE_FINLAND_ID } from './common_utils';

export const advanceSearchFieldHeaderCommon = {
    dataValueSelectionHeaderClass: '.mobileFieldSection',
    showValueInHeaderClass: '.advance-search-tool__row_col-data-value',
    showLocationSelectedValueInHeader() {
        let selectedLocationValue = '';
        let $selectedLocations = $('#advance_search #regionTownSelected option:selected');
        selectedLocationValue =
            $selectedLocations.length > 1 ? Translations.advanced_search.multiple : $selectedLocations.text();

        // For Outside Finland,  locations hidden dropdown displays 15 (Outside Finland) in text instead of caption
        return selectedLocationValue === REGION_OUTSIDE_FINLAND_ID
            ? Translations.advanced_search.outside_finland
            : selectedLocationValue;
    },
    showAdModificationSinceSelectedValueInHeader(fieldName) {
        let $modificationDays = $(`#advance_search #${fieldName} option:selected`);
        return $modificationDays.val() ? $modificationDays.text() : '';
    },
    prepareFieldHeaderValueByFieldType(object, unit) {
        let selectedFieldValue = '';
        let type = object.attr('type');
        let elementName = object.attr('name');
        if (['checkbox', 'radio'].includes(type)) {
            selectedFieldValue = $(`#advance_search input[name="${elementName}"]:checked`)
                .map(function () {
                    return $(this).next('label').text() !== Translations.any ? $(this).next('label').text() : '';
                })
                .get();

            selectedFieldValue =
                selectedFieldValue.length > 1 ? Translations.advanced_search.multiple : selectedFieldValue;
        } else if (['text', 'number'].includes(type)) {
            let fromField = elementName.replace('To', 'From');
            let toField = elementName.replace('From', 'To');
            const unitValue = unit || '';
            selectedFieldValue = object.hasClass('rangeField')
                ? advanceSearchFieldHeaderCommon.getValueForRangeField(fromField, toField, true, unitValue)
                : object.val();
        }

        advanceSearchFieldHeaderCommon.updateFieldHeader(object, selectedFieldValue);
    },
    isSectionTitleEmpty(object) {
        return !object.closest('#advance_search .post-ad__section').find('.post-ad__section_title-data-value').text();
    },
    updateFieldHeader(object, selectedFieldValue) {
        object
            .closest(`#advance_search ${this.dataValueSelectionHeaderClass}`)
            .find(this.showValueInHeaderClass)
            .text(selectedFieldValue);
    },
    getValueForRangeField(fromField, toField, isFreeFormat, unit, firstRangePartFromValue) {
        // firstRangePartFromValue : when both from/to value exist then only using this param to display from value to avoid unit value to display twice.
        const useFirstRangePart = firstRangePartFromValue || false;
        const freeFormatMode = isFreeFormat || false;
        const unitSuffix = unit || '' ? ` ${unit}` : '';
        let $fromFieldSelector = freeFormatMode
            ? $(`#advance_search #${fromField}`)
            : $(`#advance_search #${fromField} option:selected`);
        let fromValue = $fromFieldSelector.val() || '';
        let fromText = $fromFieldSelector.text() || '';

        let $toFieldSelector = freeFormatMode
            ? $(`#advance_search #${toField}`)
            : $(`#advance_search #${toField} option:selected`);
        let toValue = $toFieldSelector.val() || '';
        let toText = $toFieldSelector.text() || '';

        fromValue =
            fromValue && $fromFieldSelector.hasClass('numberFormat')
                ? commonUtils.number_format(fromValue, 0, ',', ' ')
                : fromValue;
        toValue =
            toValue && $toFieldSelector.hasClass('numberFormat')
                ? commonUtils.number_format(toValue, 0, ',', ' ')
                : toValue;
        return advanceSearchFieldHeaderCommon.formatFromToValue(
            fromValue,
            toValue,
            fromText,
            toText,
            freeFormatMode,
            unitSuffix,
            useFirstRangePart
        );
    },
    formatFromToValue(fromValue, toValue, fromText, toText, isFreeFormat, unit, firstRangePartFromValue) {
        let rangeValue = '';
        let formattedFromValue = '';
        let formattedToValue = '';

        if (fromValue) {
            let fromFieldValue =
                firstRangePartFromValue && !commonUtils.isNettivene()
                    ? advanceSearchFieldHeaderCommon.formatFromValue(fromValue)
                    : fromText;
            formattedFromValue = `${isFreeFormat ? fromValue : fromFieldValue} ${unit}`;
        }

        if (toValue) {
            formattedToValue = `${isFreeFormat ? toValue : toText} ${unit}`;
        }

        if (fromValue && toValue) {
            rangeValue = `${formattedFromValue} - ${formattedToValue}`;
        } else if (fromValue) {
            rangeValue = `${formattedFromValue} - `;
        } else if (toValue) {
            rangeValue = ` - ${formattedToValue}`;
        }

        return rangeValue;
    },
    formatFromValue(fromValue) {
        let decimalPoint = ',';
        let decimal = 0;

        // Keep floating value as it is else format it
        if (fromValue.indexOf('.') > 0) {
            decimalPoint = '.';
            decimal = 1;
        }

        return commonUtils.number_format(fromValue, decimal, decimalPoint, ' ');
    },
    getSelectedCheckboxValues(elementName) {
        return $(`#advance_search input[name = "${elementName}"]:checked`)
            .map(function () {
                let labelText = $(this).next('label').text();
                return labelText !== Translations.any ? labelText : '';
            })
            .get();
    },
};
